import styled from 'styled-components'

export const DragItemContainer = styled.div`
  &:hover {
    .match-list-icon-wrapper svg {
      fill: ${(props) =>
        props.theme.widgets.matchList.iconCloseHoverColor} !important;
    }
  }
`
